export const initialState = {
  data: [],
  errors: undefined,
  loading: false
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case 'notificationTypeFetch': {
      return { ...state, loading: true };
    }
    case 'notificationTypeFetchSuccess': {
      return { ...state, loading: false, data: action.payload };
    }
    case 'notificationTypeFetchError': {
      return { ...state, loading: true, errors: action.payload };
    }
    default: {
      return state;
    }
  }
}

export { reducer as notificationTypeReducer }